"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOfferUnderBuyerDto = instanceOfOfferUnderBuyerDto;
exports.OfferUnderBuyerDtoFromJSON = OfferUnderBuyerDtoFromJSON;
exports.OfferUnderBuyerDtoFromJSONTyped = OfferUnderBuyerDtoFromJSONTyped;
exports.OfferUnderBuyerDtoToJSON = OfferUnderBuyerDtoToJSON;
exports.OfferUnderBuyerDtoToJSONTyped = OfferUnderBuyerDtoToJSONTyped;
var OfferUnderBuyerUserDto_1 = require("./OfferUnderBuyerUserDto");
/**
 * Check if a given object implements the OfferUnderBuyerDto interface.
 */
function instanceOfOfferUnderBuyerDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('partyType' in value) || value['partyType'] === undefined)
        return false;
    if (!('isPrimary' in value) || value['isPrimary'] === undefined)
        return false;
    return true;
}
function OfferUnderBuyerDtoFromJSON(json) {
    return OfferUnderBuyerDtoFromJSONTyped(json, false);
}
function OfferUnderBuyerDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'partyType': json['partyType'],
        'isPrimary': json['isPrimary'],
        'user': json['user'] == null ? undefined : (0, OfferUnderBuyerUserDto_1.OfferUnderBuyerUserDtoFromJSON)(json['user']),
    };
}
function OfferUnderBuyerDtoToJSON(json) {
    return OfferUnderBuyerDtoToJSONTyped(json, false);
}
function OfferUnderBuyerDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'partyType': value['partyType'],
        'isPrimary': value['isPrimary'],
        'user': (0, OfferUnderBuyerUserDto_1.OfferUnderBuyerUserDtoToJSON)(value['user']),
    };
}
